import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { HouseVisitEventList } from "./HouseVisitEventList";
import { HouseVisitEventCreate } from "./HouseVisitEventCreate";
import { HouseVisitEventEdit } from "./HouseVisitEventEdit";
import { HouseVisitEventShow } from "./HouseVisitEventShow";

export default {
  list: HouseVisitEventList,
  create: HouseVisitEventCreate,
  edit: HouseVisitEventEdit,
  show: HouseVisitEventShow,
  icon: HomeWorkIcon,
  label: "Events",
  options: { label: "Events" },
  name: "houseVisitEvents",
};
